import styled, { css } from 'styled-components';
import 'react-toastify/dist/ReactToastify.min.css';
export const defaultToastifyCSS = css `
  /* ------------------------------------------- */
  /* This CSS is to keep the rest of the toasts  */
  /* appearing how they do by default            */
  /*                                             */
  /* We must do this because the default toast   */
  /* container is too small for our requirements */
  /*                                             */
  pointer-events: none;
  width: calc(100vw - 1em - 8px) !important;
  min-width: calc(100vw - 1em - 8px) !important;
  max-width: calc(100vw - 1em - 8px) !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  .toastify__toast {
    max-height: 48px;
    overflow: hidden;
  }
  .toastify__toast-body {
    padding: 0;
  }

  /* ------------------------------------------- */
`;
export const BKJToastOuterWrapperCSS = css `
  /* width: calc(100% - 200px) !important; */
  margin-left: auto;
  padding: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin: 0 !important;
  background-color: #ffffff !important;
  border-top: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  box-shadow: 0 2px 8px 0 rgba(13, 51, 32, 0.3) !important;
  height: 48px !important;
  min-height: 48px !important;
  border-radius: 4px !important;
  max-height: 48px !important;
  margin-bottom: 8px !important;
  overflow-y: visible !important;
  overflow-x: visible !important;
  &:last-child {
    margin-bottom: 0;
  }
`;
export const BKJToastBodyCSS = css `
  padding-top: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
  padding-left: 0px !important;
  margin: 0 !important;
  width: 100% !important;
  border-top: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  max-height: 48px;
  div {
    width: 100%;
  }
`;
export const BKJToastProgressBarCSS = css `
  background-color: #45424e30 !important;
  height: 1px !important;
`;
export const BKJToastCloseButtonCSS = css `
  position: absolute !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  right: 12px !important;
  color: #45424e !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
`;
export const ToastWrapper = styled.div `
  display: flex;
  width: 100%;
  align-items: center;
`;
export const ToastIconWrapper = styled.div `
  transform: translateX(-1px);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  width: 48px;
  min-width: 48px;
  max-width: 48px;
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ variant, theme }) => theme.toast[variant]}
`;
export const BKJToastTextWrapper = styled.div `
  height: 100%;
  padding-right: 38px;
  padding-left: 12px;
  flex: 1;
  min-width: 0;
`;
export const BKJToastText = styled.p `
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  ::first-letter {
    text-transform: capitalize;
  }
`;
//# sourceMappingURL=BKJToastMessage.styled.js.map